

import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import GrainIcon from '@mui/icons-material/Grain';
import { createTheme } from '@mui/material/styles';

import getPath from "./getPath";

const theme = createTheme();

const iconSx = { mr: theme.spacing(0.5), width: 20, height: 20 };
const linkSx = { display: 'flex', color: "#757575", fontSize: "0.8em"};

export default function GPAP_Breadcrumb() {  

    const submission = (window.location.href.includes("submission") || window.location.href.includes("submit") || window.location.href.includes("selectgroup") || window.location.href.includes("selectexperiments"));
    let submission_link = (submission) ? "#/submission" : "#/management";


    const url_fields = window.location.href.split('#');
    const url_basic = url_fields[0];
    
    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link color="textPrimary" sx={linkSx} href={window.location.origin}>
                <HomeIcon sx={iconSx} />
                GPAP Home
            </Link>
            <Link
                color="textPrimary"
                sx={linkSx}
                href={url_basic + submission_link}
            >
                <CloudUploadIcon sx={iconSx} />
                {(submission) ? "Data Submission" : "Data Management"}
            </Link>
            <Typography color="textPrimary" sx={linkSx}>
                <GrainIcon sx={iconSx} />
                {getPath(window.location.hash)}
            </Typography>            
        </Breadcrumbs>
    );
}